export function objectEmpty(object) {
    for (const prop in object) {
        if (!!object[prop]) {
            return false;
        }
    }

    return true;
}
